import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-stethoscope',
  templateUrl: './svg-stethoscope.component.html',
})
export class SvgStethoscopeComponent {
  constructor() {}
}
